/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/trainer.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var fitness$service_v1_client_pb = require('../../fitness-service/v1/client_pb.js')

var fitness$service_v1_common_pb = require('../../fitness-service/v1/common_pb.js')

var fitness$service_v1_workout_pb = require('../../fitness-service/v1/workout_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./trainer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.TrainerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.TrainerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetMyClientsRequest,
 *   !proto.fitness.service.v1.GetMyClientsResponse>}
 */
const methodDescriptor_TrainerService_GetMyClients = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetMyClients',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetMyClientsRequest,
  proto.fitness.service.v1.GetMyClientsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetMyClientsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetMyClientsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetMyClientsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetMyClientsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetMyClientsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getMyClients =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyClients',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyClients,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetMyClientsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetMyClientsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getMyClients =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyClients',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyClients);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetMyProfileRequest,
 *   !proto.fitness.service.v1.GetMyProfileResponse>}
 */
const methodDescriptor_TrainerService_GetMyProfile = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetMyProfile',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetMyProfileRequest,
  proto.fitness.service.v1.GetMyProfileResponse,
  /**
   * @param {!proto.fitness.service.v1.GetMyProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetMyProfileResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetMyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetMyProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetMyProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getMyProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyProfile',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyProfile,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetMyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetMyProfileResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getMyProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyProfile',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateMyProfileRequest,
 *   !proto.fitness.service.v1.UpdateMyProfileResponse>}
 */
const methodDescriptor_TrainerService_UpdateMyProfile = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/UpdateMyProfile',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateMyProfileRequest,
  proto.fitness.service.v1.UpdateMyProfileResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateMyProfileResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateMyProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateMyProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.updateMyProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateMyProfile',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateMyProfile,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateMyProfileResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.updateMyProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateMyProfile',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateMyProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CreateGroupRequest,
 *   !proto.fitness.service.v1.CreateGroupResponse>}
 */
const methodDescriptor_TrainerService_CreateGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/CreateGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CreateGroupRequest,
  proto.fitness.service.v1.CreateGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.CreateGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.CreateGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CreateGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.CreateGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.CreateGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.createGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/CreateGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_CreateGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CreateGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.CreateGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.createGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/CreateGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_CreateGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetMyGroupsRequest,
 *   !proto.fitness.service.v1.GetMyGroupsResponse>}
 */
const methodDescriptor_TrainerService_GetMyGroups = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetMyGroups',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetMyGroupsRequest,
  proto.fitness.service.v1.GetMyGroupsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetMyGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetMyGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetMyGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetMyGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetMyGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getMyGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyGroups',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyGroups,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetMyGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetMyGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getMyGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetMyGroups',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetMyGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetGroupDetailsRequest,
 *   !proto.fitness.service.v1.GetGroupDetailsResponse>}
 */
const methodDescriptor_TrainerService_GetGroupDetails = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetGroupDetails',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetGroupDetailsRequest,
  proto.fitness.service.v1.GetGroupDetailsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetGroupDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetGroupDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetGroupDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getGroupDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupDetails',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupDetails,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetGroupDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getGroupDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupDetails',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateGroupRequest,
 *   !proto.fitness.service.v1.UpdateGroupResponse>}
 */
const methodDescriptor_TrainerService_UpdateGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/UpdateGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateGroupRequest,
  proto.fitness.service.v1.UpdateGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.updateGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.updateGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteGroupRequest,
 *   !proto.fitness.service.v1.DeleteGroupResponse>}
 */
const methodDescriptor_TrainerService_DeleteGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/DeleteGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeleteGroupRequest,
  proto.fitness.service.v1.DeleteGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.DeleteGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.deleteGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.deleteGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.AddClientToGroupRequest,
 *   !proto.fitness.service.v1.AddClientToGroupResponse>}
 */
const methodDescriptor_TrainerService_AddClientToGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/AddClientToGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.AddClientToGroupRequest,
  proto.fitness.service.v1.AddClientToGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.AddClientToGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AddClientToGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.AddClientToGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AddClientToGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AddClientToGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.addClientToGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/AddClientToGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_AddClientToGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.AddClientToGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AddClientToGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.addClientToGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/AddClientToGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_AddClientToGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.RemoveClientFromGroupRequest,
 *   !proto.fitness.service.v1.RemoveClientFromGroupResponse>}
 */
const methodDescriptor_TrainerService_RemoveClientFromGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/RemoveClientFromGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.RemoveClientFromGroupRequest,
  proto.fitness.service.v1.RemoveClientFromGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.RemoveClientFromGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.RemoveClientFromGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.RemoveClientFromGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.removeClientFromGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/RemoveClientFromGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_RemoveClientFromGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.RemoveClientFromGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.removeClientFromGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/RemoveClientFromGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_RemoveClientFromGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.MoveClientBetweenGroupsRequest,
 *   !proto.fitness.service.v1.MoveClientBetweenGroupsResponse>}
 */
const methodDescriptor_TrainerService_MoveClientBetweenGroups = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/MoveClientBetweenGroups',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.MoveClientBetweenGroupsRequest,
  proto.fitness.service.v1.MoveClientBetweenGroupsResponse,
  /**
   * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.MoveClientBetweenGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.MoveClientBetweenGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.MoveClientBetweenGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.moveClientBetweenGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/MoveClientBetweenGroups',
      request,
      metadata || {},
      methodDescriptor_TrainerService_MoveClientBetweenGroups,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.MoveClientBetweenGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.moveClientBetweenGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/MoveClientBetweenGroups',
      request,
      metadata || {},
      methodDescriptor_TrainerService_MoveClientBetweenGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CreateGroupWorkoutPlanRequest,
 *   !proto.fitness.service.v1.CreateGroupWorkoutPlanResponse>}
 */
const methodDescriptor_TrainerService_CreateGroupWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/CreateGroupWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CreateGroupWorkoutPlanRequest,
  proto.fitness.service.v1.CreateGroupWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.CreateGroupWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.createGroupWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/CreateGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_CreateGroupWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.createGroupWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/CreateGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_CreateGroupWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest,
 *   !proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse>}
 */
const methodDescriptor_TrainerService_UpdateGroupWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/UpdateGroupWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest,
  proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.updateGroupWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateGroupWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.updateGroupWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/UpdateGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_UpdateGroupWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest,
 *   !proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse>}
 */
const methodDescriptor_TrainerService_DeleteGroupWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/DeleteGroupWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest,
  proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.deleteGroupWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteGroupWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.deleteGroupWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteGroupWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteGroupWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.AssignWorkoutToGroupRequest,
 *   !proto.fitness.service.v1.AssignWorkoutToGroupResponse>}
 */
const methodDescriptor_TrainerService_AssignWorkoutToGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/AssignWorkoutToGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.AssignWorkoutToGroupRequest,
  proto.fitness.service.v1.AssignWorkoutToGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AssignWorkoutToGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AssignWorkoutToGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AssignWorkoutToGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.assignWorkoutToGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/AssignWorkoutToGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_AssignWorkoutToGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AssignWorkoutToGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.assignWorkoutToGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/AssignWorkoutToGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_AssignWorkoutToGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetGroupWorkoutsRequest,
 *   !proto.fitness.service.v1.GetGroupWorkoutsResponse>}
 */
const methodDescriptor_TrainerService_GetGroupWorkouts = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetGroupWorkouts',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetGroupWorkoutsRequest,
  proto.fitness.service.v1.GetGroupWorkoutsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetGroupWorkoutsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetGroupWorkoutsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetGroupWorkoutsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getGroupWorkouts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupWorkouts',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupWorkouts,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetGroupWorkoutsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getGroupWorkouts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupWorkouts',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupWorkouts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.RemoveWorkoutFromGroupRequest,
 *   !proto.fitness.service.v1.RemoveWorkoutFromGroupResponse>}
 */
const methodDescriptor_TrainerService_RemoveWorkoutFromGroup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/RemoveWorkoutFromGroup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.RemoveWorkoutFromGroupRequest,
  proto.fitness.service.v1.RemoveWorkoutFromGroupResponse,
  /**
   * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.RemoveWorkoutFromGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.removeWorkoutFromGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/RemoveWorkoutFromGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_RemoveWorkoutFromGroup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.removeWorkoutFromGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/RemoveWorkoutFromGroup',
      request,
      metadata || {},
      methodDescriptor_TrainerService_RemoveWorkoutFromGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetGroupMembershipHistoryRequest,
 *   !proto.fitness.service.v1.GetGroupMembershipHistoryResponse>}
 */
const methodDescriptor_TrainerService_GetGroupMembershipHistory = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/GetGroupMembershipHistory',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetGroupMembershipHistoryRequest,
  proto.fitness.service.v1.GetGroupMembershipHistoryResponse,
  /**
   * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetGroupMembershipHistoryResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetGroupMembershipHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetGroupMembershipHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.getGroupMembershipHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupMembershipHistory',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupMembershipHistory,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetGroupMembershipHistoryResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.getGroupMembershipHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/GetGroupMembershipHistory',
      request,
      metadata || {},
      methodDescriptor_TrainerService_GetGroupMembershipHistory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteAccountRequest,
 *   !proto.fitness.service.v1.DeleteAccountResponse>}
 */
const methodDescriptor_TrainerService_DeleteAccount = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.TrainerService/DeleteAccount',
  grpc.web.MethodType.UNARY,
  fitness$service_v1_common_pb.DeleteAccountRequest,
  fitness$service_v1_common_pb.DeleteAccountResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  fitness$service_v1_common_pb.DeleteAccountResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.TrainerServiceClient.prototype.deleteAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteAccount',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteAccount,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteAccountResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.TrainerServicePromiseClient.prototype.deleteAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.TrainerService/DeleteAccount',
      request,
      metadata || {},
      methodDescriptor_TrainerService_DeleteAccount);
};


module.exports = proto.fitness.service.v1;

